



























































































import { Component, Vue } from 'vue-property-decorator';
import { AuthorizedUser, RegulatorAccount } from '@/app/shared/utilities/static-types';
import { getUserById } from '@adminRoles/shared/actions';
import { getCurrentUser } from '@/app/shared/firebase/firebase-user';
import { loadRegulators } from '../shared/actions';
import { AdminRoutes } from '@/app/shared/utilities/routes-names';
import { signInToPlatformWithUserAsAdmin } from '@/app/shared/utilities/helper-functions';

@Component({
  components: {},
  data() {
    return {
      headers: [
        {
          text: this.$t('organization_name').toString(),
          value: 'NAME',
          sortable: true,
        },
        {
          text: this.$t('email').toString(),
          value: 'EMAIL',
          sortable: true,
        },
        {
          text: this.$t('actions').toString(),
          value: 'ACTIONS',
          sortable: false,
        },
      ],
    };
  },
})
export default class StoreOwners extends Vue {
  public currentUser: AuthorizedUser | null = null;
  public regulators: RegulatorAccount[] = [];
  public loading = false;

  public newRegulatorRoute = AdminRoutes.CREATE_REGULATOR;

  public pagination = {
    sortBy: 'NAME',
    descending: false,
  };

  public changeSort(column: string): void {
    if (this.pagination.sortBy === column) {
      this.pagination.descending = !this.pagination.descending;
    } else {
      this.pagination.sortBy = column;
      this.pagination.descending = false;
    }
  }

  public async created() {
    this.loading = true;
    this.currentUser = await this.loadCurrentUser() || null;
    this.regulators = await loadRegulators();
    this.loading = false;

  }

  public async editStoreOwner(id: string) {
    this.$router.push({
      ...AdminRoutes.EDIT_REGULATOR,
      params: {
        id,
      },
    });
  }
  public async signInToPlatformWithUser(user: AuthorizedUser) {
    try {
      this.loading = true;
      await signInToPlatformWithUserAsAdmin(user);
    } finally {
      this.loading = false;
    }
  }
  public async loadCurrentUser() {
    const { uid } = (await getCurrentUser())!;
    return getUserById(uid);
  }
}
